import styled from 'styled-components';

import Icon from '@ant-design/icons';
import { Modal as AntdModal, Skeleton } from 'antd';

import CloseSvg from 'global/Icons/CloseSvg';

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 20px;
  min-width: 480px;

  h1 {
    font-size: 16px;
    line-height: 22px;
    font-family: ProximaNovaBd;
    color: #333333;
    margin: 0;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;
  height: 20px;
`;

export const Modal = styled(AntdModal)`
  margin: 0 auto;
  top: 0 !important;
  height: 100vh;
  display: flex;
  align-items: center;
  padding: 0;

  & .ant-modal-wrap {
    z-index: 9999;
  }

  & .ant-modal-header {
    display: none;
  }

  & .ant-modal-content {
    border-radius: 4px;
    max-height: 95vh;
  }

  & .ant-modal-body {
    padding: 0;
  }
`;

export const CloseIcon = styled(Icon).attrs({
  component: CloseSvg,
})`
  color: #969696;
  font-size: 12px;
  transition: 0.3s color linear;
`;

export const AraArbSkeletons = styled.div`
  width: 520px;
  padding: 0 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SkeletonContainer = styled.div`
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  border: 1px solid rgb(237, 237, 237);
  align-items: center;
  height: 40px;
  padding: 0 10px;
  gap: 10px;
`;

export const SkeletonPrice = styled(Skeleton).attrs({
  avatar: false,
  paragraph: { rows: 0 },
  loading: true,
  active: true,
})`
  border-radius: 4px;
  height: 20px;
  width: 80px;

  .ant-skeleton-content {
    width: 80px;

    .ant-skeleton-title {
      margin: 0;
      width: 100% !important;
      height: 20px;
    }
  }

  .ant-skeleton-paragraph {
    display: none;
  }
`;

export const SkeletonPercentage = styled(SkeletonPrice)`
  width: 100px;
`;

export const SkeletonPercentageBase = styled(SkeletonPrice)`
  margin-left: auto;
`;

export const ErrorWrapper = styled.div`
  padding: 20px 20px 40px;
`;
